import { t } from '../i18n/index.js';
import { flagEmoji } from '../domain/flagEmoji.js';

/**
 * Render a "Changes since last visit" notice into `container`.
 *
 * @param {import('../domain/changeMonitor.js').AppChange[]} changes
 * @param {(countryCode: string) => string} countryName - resolver for localised country name
 * @param {HTMLElement} container
 */
export function renderChangeNotice(changes, countryName, container) {
  if (!container) return;

  if (!changes || changes.length === 0) {
    container.hidden = true;
    container.innerHTML = '';
    return;
  }

  const items = changes.map((ch) => {
    const flag = flagEmoji(ch.country);
    const cname = countryName(ch.country) || ch.country.toUpperCase();
    const label = `${flag} ${cname}`;

    if (ch.type === 'version') {
      return `<li>${t('changes.version', { country: label, prev: String(ch.prev), current: String(ch.current) })}</li>`;
    }
    const prevFmt = typeof ch.prev === 'number' ? `$${ch.prev.toFixed(2)}` : String(ch.prev);
    const currFmt = ch.formattedPrice ?? (typeof ch.current === 'number' ? `$${ch.current.toFixed(2)}` : String(ch.current));
    const isPriceDown = typeof ch.current === 'number' && typeof ch.prev === 'number' && ch.current < ch.prev;
    const key = isPriceDown ? 'changes.priceDown' : 'changes.priceUp';
    return `<li>${t(key, { country: label, prev: prevFmt, current: currFmt })}</li>`;
  });

  container.innerHTML = `
    <details class="change-notice" open>
      <summary class="change-notice__summary">
        <span class="change-notice__title">${t('changes.title')}</span>
        <span class="change-notice__count">${changes.length}</span>
      </summary>
      <ul class="change-notice__list">${items.join('')}</ul>
      <button class="change-notice__dismiss" type="button">${t('changes.dismiss')}</button>
    </details>
  `.trim();

  container.hidden = false;

  container.querySelector('.change-notice__dismiss')?.addEventListener('click', () => {
    container.hidden = true;
    container.innerHTML = '';
  });
}
